function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { connect } from "react-redux";
import NotificationDialog from "../components/NotificationDialog";
import { dismissNotification } from "../actions";
var mapStateToProps = function(state, ownProps) {
    return {
        notifications: _toConsumableArray(state.errors).concat(_toConsumableArray(state.notifications)).filter(function(n) {
            return !n.seen;
        }),
        isPreview: window.location && window.location.pathname.indexOf("/preview/") > -1
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        dismiss: function(id) {
            dispatch(dismissNotification({
                id: id
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationDialog);
